export const FORCE_PASSWORD_CHANGE_EVENT = 'force-password-change';

export type ForcePasswordChangeDetail = {
    message?: string;
    username?: string;
    password?: string;
};

let lastEmittedAt = 0;
const EMIT_COOLDOWN_MS = 3000;

export function emitForcePasswordChange(detail?: ForcePasswordChangeDetail) {
    const now = Date.now();
    if (now - lastEmittedAt < EMIT_COOLDOWN_MS) {
        return;
    }
    lastEmittedAt = now;
    window.dispatchEvent(new CustomEvent(FORCE_PASSWORD_CHANGE_EVENT, { detail }));
}
